import React from 'react';
export const ThemeContext = React.createContext(
   {
      darkMode: (true || window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches),
      toggleTheme: () => { }
   }
);
